(() => {
  if (customElements.get('luminant-watch-hero')) return;
  const sdk = 'https://cdn.spline.design/@splinetool/viewer@2.0.75/build/spline-viewer.js';
  let sdkPromise;
  function loadSdk() {
    if (customElements.get('spline-viewer')) return Promise.resolve();
    if (!sdkPromise) sdkPromise = import(sdk).then(() => customElements.whenDefined('spline-viewer')).catch(error => { sdkPromise = null; throw error; });
    return sdkPromise;
  }
  class WatchHero extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', () => this.sync(), { signal: this.abort.signal });
      const turnWatch = () => {
        if (this.dataset.state !== 'ready') return;
        const frame = this.querySelector('spline-viewer')?.shadowRoot?.querySelector('iframe[title="Spline HTML content"]');
        frame?.contentWindow?.postMessage({ type: 'luminant:spin' }, '*');
      };
      this.querySelector('button').addEventListener('click', turnWatch, { signal: this.abort.signal });
      this.querySelector('.luminant-hero__viewer').addEventListener('click', turnWatch, { signal: this.abort.signal });
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { this.visible = true; this.sync(); this.observer.disconnect(); }
      }, { rootMargin: '250px' });
      this.observer.observe(this);
    }
    async showStill() {
      const generation = this.generation = (this.generation || 0) + 1;
      clearTimeout(this.loadTimeout);
      cancelAnimationFrame(this.revealFrame);
      this.querySelector('.luminant-hero__viewer').replaceChildren();
      this.querySelector('button').hidden = true;
      this.dataset.state = 'fallback';
      try { await this.querySelector('.luminant-hero__poster').decode(); } catch (error) {}
      if (this.isConnected && generation === this.generation) this.dataset.state = 'static';
    }
    async sync() {
      if (this.motion.matches || navigator.connection?.saveData) {
        this.showStill();
        return;
      }
      if (!this.visible || this.querySelector('spline-viewer') || this.dataset.state === 'loading') return;
      const generation = this.generation = (this.generation || 0) + 1;
      this.dataset.state = 'loading';
      this.loadTimeout = setTimeout(() => this.showStill(), 30000);
      try {
        const url = new URL(this.dataset.scene);
        if (url.protocol !== 'https:' || url.hostname !== 'prod.spline.design') throw new Error('Invalid Spline scene URL');
        await loadSdk();
        if (!this.isConnected || generation !== this.generation || this.motion.matches) return;
        const viewer = document.createElement('spline-viewer');
        viewer.setAttribute('renderer', 'auto');
        viewer.setAttribute('loading', 'eager');
        viewer.setAttribute('background', 'transparent');
        viewer.setAttribute('events-target', 'global');
        viewer.setAttribute('aria-hidden', 'true');
        viewer.addEventListener('load-complete', () => {
          if (!this.isConnected || generation !== this.generation) return;
          clearTimeout(this.loadTimeout);
          const style = document.createElement('style');
          style.textContent = 'iframe[title="Spline HTML content"] { pointer-events: none !important; }';
          viewer.shadowRoot?.append(style);
          this.revealFrame = requestAnimationFrame(() => {
            this.revealFrame = requestAnimationFrame(() => {
              if (!this.isConnected || generation !== this.generation) return;
              this.dataset.state = 'ready';
              this.querySelector('button').hidden = false;
            });
          });
        });
        const fallback = () => {
          if (this.isConnected && generation === this.generation) this.showStill();
        };
        viewer.addEventListener('error', fallback);
        viewer.addEventListener('context-loss', fallback);
        viewer.setAttribute('url', url.href);
        this.querySelector('.luminant-hero__viewer').append(viewer);
      } catch (error) {
        if (this.isConnected && generation === this.generation) this.showStill();
        console.warn('Luminant: displaying the watch still.', error);
      }
    }
    disconnectedCallback() {
      this.generation = (this.generation || 0) + 1;
      clearTimeout(this.loadTimeout);
      cancelAnimationFrame(this.revealFrame);
      this.abort?.abort(); this.abort = null;
      this.observer?.disconnect();
      this.querySelector('.luminant-hero__viewer')?.replaceChildren();
      this.dataset.state = 'static';
    }
  }
  customElements.define('luminant-watch-hero', WatchHero);
})();
